module.exports = __webpack_public_path__ + "img/1534153995.01e4a5f5.jpg";